import { type InputRule, markTypeInputRule } from "@handlewithcare/prosemirror-inputrules";
import { type MarkType } from "prosemirror-model";

// Given an em markType returns an input rule that turns `"_text_"` in a text block
// into an <em> tag.

// match the beginning of the line or match when the the _ is preceded by a space

export const emUnderscoreRule = (markType: MarkType): InputRule => {
	return markTypeInputRule(/(?<prefix>^|\s)_(?<content>[^_]+)_$/d, markType);
};
